import { render } from "./RntrcPixBloco.vue?vue&type=template&id=d1fe7d0a&scoped=true"
import script from "./RntrcPixBloco.vue?vue&type=script&lang=ts"
export * from "./RntrcPixBloco.vue?vue&type=script&lang=ts"

import "./RntrcPixBloco.vue?vue&type=style&index=0&id=d1fe7d0a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d1fe7d0a"

export default script